import gql from 'graphql-tag';

export const NAME =
  'compositions_CustomersWidget_caseCustomerBillingPreferencesQuery';

const query = gql`
  query ${NAME} ($caseNumber: String!) {
    case (caseNumber: $caseNumber) {
      id
      customer {
        ... on Customer {
          id
          billingPreferences {
            creditCardRuleAbbreviation
            creditCardRuleName
            purchaseOrderRule
            casingBrandOff
            casingBrandOn
            contractNumber
            mountSpareFirst
            odometer
            releaseNumber
            terminalLocation
            tireSerialNumber
            vehicleLicenseTag
            vehicleYearModel
            vin
            tireLimit
            wheelLimit
            fleetReferenceNumber
          }
        }

        ... on StoreCustomer {
          id
          billingPreferences {
            creditCardRuleAbbreviation
            creditCardRuleName
            purchaseOrderRule
            casingBrandOff
            casingBrandOn
            contractNumber
            mountSpareFirst
            odometer
            releaseNumber
            terminalLocation
            tireSerialNumber
            vehicleLicenseTag
            vehicleYearModel
            vin
            tireLimit
            wheelLimit
            fleetReferenceNumber
          }
        }
      }
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/CustomerDetails/BillingPreferences/caseCustomerBillingPreferencesQuery.js